import React from 'react'
import { SvgIconProps } from './Home'

const SvgPointsIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M17.912 6.785c-.187-.565-.656-.942-1.219-1.13l-4.126-.943L10.41.848a2.196 2.196 0 00-.657-.66A1.76 1.76 0 009.003 0C8.44 0 7.878.283 7.596.848L5.44 4.712l-4.126.942C.75 5.75.28 6.22.093 6.785a1.653 1.653 0 00.282 1.602L3.19 11.78l-.376 4.43c-.093.565.188 1.13.657 1.507.281.189.563.283.938.283.281 0 .469-.094.656-.189l3.845-1.79 3.845 1.79c.188.095.47.189.657.189.375 0 .656-.094.938-.283.468-.377.75-.942.656-1.508l-.375-4.523 2.813-3.393c.563-.377.657-.942.47-1.508zm-5.158 4.712l.375 4.241-3.657-1.696c-.094-.094-.281-.094-.469-.094-.188 0-.281 0-.469.094L4.97 15.644l.376-4.24c0-.284-.094-.566-.282-.755L2.438 7.54l3.94-.942c.28-.094.562-.283.656-.471l2.063-3.582 1.97 3.582c.187.282.374.47.656.47l3.938.943-2.72 3.204c-.187.189-.28.472-.187.754z"
    ></path>
  </svg>
)


export default SvgPointsIcon